import type { CountMode } from "../../types";
import { SelectPicker } from "../SelectPicker";

type CountModeFieldsProps = {
    countMode: CountMode | "inherit";
    countModeOptions: { id: string; value: CountMode | "inherit"; name: string }[];
    getColumnOptions: () => { id: string; value: string; name: string; sortOrder?: number }[];
    distinctColumn: string;
    validationField: string;
    onCountModeChange: (value: string) => void;
    onDistinctColumnChange: (value: string) => void;
};

export function CountModeFields({
    countMode,
    countModeOptions,
    getColumnOptions,
    distinctColumn,
    validationField,
    onCountModeChange,
    onDistinctColumnChange,
}: CountModeFieldsProps) {
    return (
        <>
            <label className="rc-label-block">
                Count
                <SelectPicker
                    options={countModeOptions}
                    value={countMode}
                    onChange={onCountModeChange}
                    searchPlaceholder="Search Count Modes..."
                />
            </label>
            {countMode === "distinct" && (
                <label className="rc-label-block" data-rc-validation={validationField}>
                    Distinct Column
                    <SelectPicker
                        options={getColumnOptions()}
                        value={distinctColumn}
                        placeholder="Select a Column..."
                        searchPlaceholder="Search Columns..."
                        onChange={onDistinctColumnChange}
                    />
                </label>
            )}
        </>
    );
}
